import {createWorker} from '@github-ui/create-worker'
import workerUrl from './find-in-diff.worker?worker&url'

export function createFindInDiffWorker() {
  return createWorker(workerUrl, {type: 'module'})
}
